import React from "react";
import GenericError from "../components/modals/generic-error/generic-error";

interface IProps {
  children?: React.ReactNode;
}

interface IState {
  hasError?: boolean;
  errorMessage?: string;
}

class ErrorBoundaryContainer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      errorMessage: error.message
    };
  }

  render() {
    if (this.state.hasError) {
      return <GenericError details={this.state.errorMessage} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundaryContainer;
